import React from 'react';
import './SkeletonLoader.css';

// Skeleton for dashboard cards (fast loading data)
const DashboardCardsSkeleton = () => {
  return (
    <div className="skeleton-container">
      {/* Header Skeleton */}
      <div className="skeleton-header">
        <div className="skeleton-title"></div>
      </div>

      {/* Three Cards Row Skeleton */}
      <div className="skeleton-cards-row">
        <div className="skeleton-card">
          <div className="skeleton-card-header">
            <div className="skeleton-text skeleton-text-large"></div>
            <div className="skeleton-text skeleton-text-medium"></div>
            <div className="skeleton-text skeleton-text-small"></div>
          </div>
          <div className="skeleton-card-content">
            <div className="skeleton-text skeleton-text-medium"></div>
            <div className="skeleton-text skeleton-text-small"></div>
            <div className="skeleton-text skeleton-text-small"></div>
          </div>
        </div>

        <div className="skeleton-card">
          <div className="skeleton-card-header">
            <div className="skeleton-text skeleton-text-large"></div>
          </div>
          <div className="skeleton-card-content">
            <div className="skeleton-input"></div>
            <div className="skeleton-input"></div>
            <div className="skeleton-select"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="skeleton-card">
          <div className="skeleton-card-header">
            <div className="skeleton-text skeleton-text-large"></div>
          </div>
          <div className="skeleton-card-content">
            <div className="skeleton-input"></div>
            <div className="skeleton-input"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>
      </div>

      {/* Create User Section Skeleton */}
      <div className="skeleton-section">
        <div className="skeleton-section-header">
          <div className="skeleton-text skeleton-text-large"></div>
        </div>
        <div className="skeleton-form">
          <div className="skeleton-input-group">
            <div className="skeleton-input"></div>
            <div className="skeleton-input"></div>
          </div>
          <div className="skeleton-input-group">
            <div className="skeleton-input"></div>
            <div className="skeleton-input"></div>
          </div>
          <div className="skeleton-button"></div>
        </div>
      </div>
    </div>
  );
};

// Skeleton for table data (slow loading)
const TableDataSkeleton = () => {
  return (
    <div className="skeleton-section">
      <div className="skeleton-section-header">
        <div className="skeleton-text skeleton-text-large"></div>
        <div className="skeleton-controls">
          <div className="skeleton-input skeleton-search"></div>
          <div className="skeleton-select"></div>
        </div>
      </div>
      
      <div className="skeleton-table-container">
        <div className="skeleton-table">
          <div className="skeleton-table-header">
            <div className="skeleton-table-cell"></div>
            <div className="skeleton-table-cell"></div>
            <div className="skeleton-table-cell"></div>
            <div className="skeleton-table-cell"></div>
            <div className="skeleton-table-cell"></div>
          </div>
          
          {/* Table Rows Skeleton */}
          {[...Array(10)].map((_, index) => (
            <div key={index} className="skeleton-table-row">
              <div className="skeleton-table-cell">
                <div className="skeleton-text skeleton-text-small"></div>
              </div>
              <div className="skeleton-table-cell">
                <div className="skeleton-text skeleton-text-small"></div>
              </div>
              <div className="skeleton-table-cell">
                <div className="skeleton-text skeleton-text-small"></div>
              </div>
              <div className="skeleton-table-cell">
                <div className="skeleton-text skeleton-text-small"></div>
              </div>
              <div className="skeleton-table-cell">
                <div className="skeleton-text skeleton-text-small"></div>
                <div className="skeleton-button skeleton-button-small"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Pagination Skeleton */}
      <div className="skeleton-pagination">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="skeleton-pagination-item"></div>
        ))}
      </div>
    </div>
  );
};

// Main skeleton loader component
const SkeletonLoader = ({ showDashboardCards = true, showTableData = true }) => {
  return (
    <div className="skeleton-container">
      {showDashboardCards && <DashboardCardsSkeleton />}
      {showTableData && <TableDataSkeleton />}
    </div>
  );
};

export default SkeletonLoader;
export { DashboardCardsSkeleton, TableDataSkeleton };